import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../utils/authorization'
import { AuthorizationLayout } from '../../common/html/AuthorizationLayout'
import { LayoutPanel } from '../../common/html/LayoutPanel'
import { Featured } from './featured/Featured'
import classes from './index.module.scss'
import { NewsAndEvents } from './newsAndEvents/NewsAndEvents'
import { selectLoadingNews } from './store/slice'
import { getNewsAndEvents, getNewsFeatured } from './store/thunk'

export const News = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const loadingFeatured = useSelector(selectLoadingNews('featured'))
  const loadingNews = useSelector(selectLoadingNews('newsAndEvent'))
  const AUTHORIZATION = useSelector(selectComponentAuthorized)
  const userType = useSelector(selectUserType)

  const allowFeature =
    AUTHORIZATION.dashboard.featured[userType.userTypeId] ===
    AUTHORIZATION_TYPE.ALLOW

  const allowNews =
    AUTHORIZATION.dashboard.fiinGroupNewsAndEvents[userType.userTypeId] ===
    AUTHORIZATION_TYPE.ALLOW

  useEffect(() => {
    if (allowFeature) {
      dispatch(getNewsFeatured())
    }
    if (allowNews) {
      dispatch(getNewsAndEvents())
    }
  }, [locale])

  return (
    <LayoutPanel
      loading={(loadingFeatured && allowFeature) || (loadingNews && allowNews)}
    >
      <Element className={classes.news}>
        <div style={{ height: '52%' }}>
          <AuthorizationLayout
            id="featured"
            title="dashboard.featured.featured"
          >
            <Featured />
          </AuthorizationLayout>
        </div>
        <div style={{ height: '48%' }}>
          <AuthorizationLayout
            id="fiinGroupNewsAndEvents"
            title="dashboard.featured.newsAndEvent"
          >
            <NewsAndEvents />
          </AuthorizationLayout>
        </div>
      </Element>
    </LayoutPanel>
  )
}
